import { atom } from "recoil";

export const supportTaskModalState = atom({
  key: "supportTaskModalState",
  default:
    /** @type {{ open: boolean; taskDetails?: any; taskId?: any; type?: string | null }} */ ({
      open: false,
      taskDetails: null,
      taskId: null,
      type: null,
    }),
});

export const isTasksUpdatedState = atom({
  key: "isTasksUpdatedState",
  default: false,
});